import { render, staticRenderFns } from "./ZonaCard.vue?vue&type=template&id=2bcaf85e"
import script from "./ZonaCard.vue?vue&type=script&lang=js"
export * from "./ZonaCard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports